import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { AxiosError, AxiosRequestConfig } from "axios";
import axiosPublicClient from "./axiosPublicClient";

/**
 * BaseQuery для публичных запросов (без авторизации)
 */
export const publicBaseQuery =
  (): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      body?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
      baseURL?: AxiosRequestConfig["baseURL"];
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, body, params, headers, baseURL }) => {
    try {
      const result = await axiosPublicClient({
        url,
        method,
        data: body ?? data,
        params,
        headers,
        baseURL,
      });
      return { data: result.data };
    } catch (error) {
      const err = error as AxiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
